module.exports = __webpack_public_path__ + "static/media/Scan@2x.4ce5465f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/Scan@2x.png
// module id = 203
// module chunks = 0